import { useEffect, useState } from 'react';
import useClient from 'api/client';
import { useParams } from 'react-router-dom';
import getDatasetSchema from 'api/Dataset/getDatasetSchema';

interface SchemaTable {
    tableUri: string;
    GlueTableName: string;
    columns: {
        count: number;
        page: number;
        pages: number;
        nodes: { label: string; typeName: string }[];
    };
}

export default function useDatasetSchema() {
    const client = useClient();
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string>('');
    const [tables, setTables] = useState<SchemaTable[]>([]);
    const [emptyTables, setEmptyTables] = useState<SchemaTable[]>([]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                if (params.uri) {
                    const response = await client.query(
                        getDatasetSchema(params.uri, {
                            page: 1,
                            pageSize: 500,
                        }),
                    );
                    if (!response.errors) {
                        setTables(
                            response.data.getDataset.tables.nodes.filter(
                                (node: SchemaTable) => node.columns.count !== 0,
                            ),
                        );
                        setEmptyTables(
                            response.data.getDataset.tables.nodes.filter(
                                (node: SchemaTable) => node.columns.count === 0,
                            ),
                        );
                    } else {
                        setError(response.errors[0]?.message);
                    }
                }
            } finally {
                setLoading(false);
            }
        };

        if (client) {
            fetchData();
        }
    }, [client, params.uri]);

    return {
        tables,
        emptyTables,
        error,
        loading,
    };
}
